import {faPencil} from '@netx/core-icons';

export const SEARCH_RULES_ACTION_ICON = <const>{
	EDIT_SEARCH: faPencil,
};

export type SearchRulesBaseEvent = typeof SEARCH_RULES_BASE_EVENT;

export const SEARCH_RULES_BASE_EVENT = `search:rules`;

export const SEARCH_RULES_EVENT = <const>{
	EDIT_SEARCH: `${SEARCH_RULES_BASE_EVENT}:edit`,
};
